module.exports = __webpack_public_path__ + "img/learn-french.25161ab9.png";